import { HSLColor } from '@yola/yola-palette-generator';
import border from '../../border';

const secondary = (params) => {
  const { hue, saturation, lightness } = border.default.secondary(params);

  return new HSLColor(hue, saturation, lightness, 0);
};

export default secondary;
